import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    Output,
    ViewChild,
} from '@angular/core';
import { IMultiYearComparisonResponseDTO } from '@modeso/types__aumico-lib-annualreport-be';
import { ControlsState, DeltaMode, ReportScope } from '../../models/controls.model';

@Component({
    selector: 'normal-state-view',
    templateUrl: './normal-state-view.component.html',
    styleUrls: ['./normal-state-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NormalStateViewComponent implements AfterViewInit, OnDestroy {
    @Input() public harmonized!: IMultiYearComparisonResponseDTO;
    @Input() public controls!: ControlsState;
    @Input() public currencies: string[] = [];
    @Input() public isAllExpanded = false;
    @Input() public exportInFlight = false;

    @Output() public yearToggled = new EventEmitter<string>();
    @Output() public deltaModeChanged = new EventEmitter<DeltaMode>();
    @Output() public reportScopeChanged = new EventEmitter<ReportScope>();
    @Output() public structModeToggled = new EventEmitter<void>();
    @Output() public nodeToggled = new EventEmitter<string>();
    @Output() public showAllDetails = new EventEmitter<void>();
    @Output() public hideAllDetails = new EventEmitter<void>();
    @Output() public exportPdf = new EventEmitter<void>();
    @Output() public languageChanged = new EventEmitter<string>();

    @ViewChild('stickyTop', { static: true }) private stickyTopRef!: ElementRef<HTMLElement>;

    /** Rendered height of the sticky controls bar — drives the table header's `top` offset. */
    public stickyTopHeight = 72;

    private resizeObserver?: ResizeObserver;

    public constructor(private readonly zone: NgZone, private readonly cdr: ChangeDetectorRef) {}

    public ngAfterViewInit(): void {
        this.resizeObserver = new ResizeObserver(() => {
            const height = Math.ceil(this.stickyTopRef.nativeElement.getBoundingClientRect().height);
            if (height !== this.stickyTopHeight) {
                this.zone.run(() => {
                    this.stickyTopHeight = height;
                    this.cdr.markForCheck();
                });
            }
        });
        this.resizeObserver.observe(this.stickyTopRef.nativeElement);
    }

    public ngOnDestroy(): void {
        this.resizeObserver?.disconnect();
    }
}
